import React from 'react'
import CardContent from '../../Shared/CardContent/CardContent'

const CardData = props => {
  return <CardContent {...props} />
}

export default CardData
